import { asCurrency, maskAccountNumber } from '@ally/aos-utils';
import { muiBankTheme, get } from '@ally/metronome-ui';
export function getNormalizedAccountType(group, type) {
    if (group === void 0) { group = 'internal'; }
    if (['external', 'ira'].includes(group))
        return group;
    // Wealth changes v3 transfer-accounts call return proper account type
    // If account type is invw (invest wealth account) or inva ( managed/robo
    // portfolio) we need to return that as type otherwise return inv
    if (group === 'invest' &&
        (!type || !['invw', 'inva'].includes(type.toLowerCase())))
        return 'inv';
    if (type)
        return type.toLowerCase();
    return 'unknown';
}
export function getNormalizedAccountStatus(status) {
    return status ? status.toLowerCase() : '';
}
export function getAccountLabel(account, excludeBalance, includeStatus) {
    var nickname = account.nickname, accountNumber = account.accountNumber, status = account.status, bankName = account.bankName, group = account.group, balance = account.balance;
    var maskedAccountNumber = maskAccountNumber(accountNumber);
    var label = "" + maskedAccountNumber;
    var includeBalance = !excludeBalance && group !== 'external';
    if (includeBalance) {
        label = label + " " + asCurrency(balance);
    }
    if (group === 'external') {
        label = (bankName || '') + " " + label + " " + (nickname || '');
    }
    else {
        label = (nickname || '') + " " + label;
    }
    label = label.trim();
    if (includeStatus) {
        label = label + " (" + status + ")";
    }
    return label;
}
export function getAccountTypeColor(accountType) {
    var colors = muiBankTheme.colors;
    if (Object.keys(colors).includes(accountType)) {
        return get.colors(accountType)({
            theme: muiBankTheme,
        });
    }
    return get.colors('slate-2')({ theme: muiBankTheme });
}
//# sourceMappingURL=utils.js.map